import { APP_INITIALIZER, inject, Provider } from '@angular/core';
import { OpenPayService } from '../services/openpay.service';

function openPayInitializerFactory() {
    const openPayService = inject(OpenPayService);

    return () => {
        try {
            openPayService.init();
        } catch (err) {
            console.warn('OpenPay: no se pudo inicializar al arrancar la app.', err);
        }
    };
}

/**
 * Provider que inicializa OpenPay.js al arrancar la aplicación.
 * Requiere que AUTH_ENVIRONMENT tenga la sección `openPay` configurada
 * y que los scripts de OpenPay.js estén cargados en index.html.
 *
 * @example
 * ```typescript
 * // En app.config.ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideOpenPayInitializer(),
 *   ]
 * };
 * ```
 */
export function provideOpenPayInitializer(): Provider {
    return {
        provide: APP_INITIALIZER,
        useFactory: openPayInitializerFactory,
        multi: true,
    };
}
